import { z } from 'zod'
import { oc } from '@orpc/contract'

export const patientStatusSchema = z.enum(['invited', 'active', 'inactive'])

// TODO: Eventually return a full patient record with all attributes required by the web.
// For now this only carries the id, computed portal status, and identity-verification status.
export const patientGet = oc
  .route({ method: 'GET', path: '/v2/patient/{id}' })
  .input(z.object({ id: z.string() }))
  .output(
    z.object({
      id: z.string(),
      status: patientStatusSchema,
      identityVerified: z.boolean(),
      identityVerifiedAt: z.string().optional(),
      identityVerifiedBy: z.string().optional(),
    }),
  )
